import { gql } from '@apollo/client';

export const GetChangelogQueryName = 'GetChangelog';

export const GET_CHANGELOG_QUERY = gql`
  query ${GetChangelogQueryName} {
    getChangelog {
      id
      version
      changes
      createdAt
      unseen
    }
  }
`;
